var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.widthLimitter)},[_c('video',{attrs:{"autoplay":"","controls":"","width":"100%"}},[_c('source',{attrs:{"src":("" + _vm.$aws_bucket_url + _vm.src)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }